import React from 'react';

import { Section, Grid } from '@gogame/components';
import { withFormFieldGroupFormField, FormField } from '@gogame/form';

import { PARTNER } from 'scenes/CustomAudiences/LookalikeAudiences/components/LookalikeAudienceForm/constants';
import {
  loadCountries,
  loadSnapchatTypes,
} from 'scenes/CustomAudiences/LookalikeAudiences/sources/fields';

import { COUNTRIES, TYPES, MULTIPLY_OPTIONS } from './constants';

const FormGroup = () => {
  return (
    <Section
      title={'Targeting'}
      subTitle={'Top % players of parent audience in a selected countries'}
    >
      <Grid container spacing={3}>
        <Grid item xs={8}>
          <FormField.MultiSelect
            padding={0}
            label={'Countries'}
            withSelectAll={false}
            withFilter={true}
            placeholder={'Select countries'}
            name={COUNTRIES}
            source={loadCountries}
            depends={[PARTNER]}
            helper={
              'Separate Lookalike for each of the selected countries will be created'
            }
            required={true}
          />
        </Grid>
        <Grid item xs={4}>
          <FormField.MultiSelect
            padding={0}
            label={'Audience sizes'}
            name={`${MULTIPLY_OPTIONS}.${TYPES}`}
            source={loadSnapchatTypes}
            required={true}
          />
        </Grid>
      </Grid>
    </Section>
  );
};

export default withFormFieldGroupFormField({})(FormGroup);
